module.exports = __webpack_public_path__ + "img/arte_over.19a0d393.gif";